import moment from 'moment';

export const name = 'quotaController';
export default function quotaController($translate, ecommerceFactory, $sce) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var vm = this;

  ecommerceFactory.createEcommerceTracking(quotaInfoCallback);

  function quotaInfoCallback(ecommerceInfo) {
    vm.ecommerceInfo = ecommerceInfo;
    let daysLeft = moment(ecommerceInfo.nextResetTime).endOf('day').diff(moment(), 'days');
    vm.daysLeft = daysLeft < 0 ? 0 : daysLeft;
    let dayInMonth = '<span class="blue">' + moment(ecommerceInfo.nextResetTime).format("Do") + '</span>';
    $translate.onReady(function(){
      vm.refreshTime = $translate.instant('imposer.composer-main.refresh_occurs', [dayInMonth]);
      vm.marketplaceTranslated = $translate.instant('imposer.composer-main.marketplace');
      //let marketPlaceLink = '<a href="/market/#/product/composer" class="blue">' + vm.marketplaceTranslated + '</a>';
      let marketPlaceLink = '<a href="/market/#/product/creativity-pack" class="blue">' + vm.marketplaceTranslated + '</a>';
      vm.increaseRecords = $translate.instant('imposer.composer-main.increase_records', [marketPlaceLink]);
    });//

    vm.to_trusted = function(html_code) {
      return $sce.trustAsHtml(html_code);
    };

    vm.changeUpperRibbonVisibility = function(){
      if(vm.isUpperRibbonRequired){
        localStorage.removeItem("isUpperRibbonDismissed");
      }else{
        localStorage.setItem("isUpperRibbonDismissed", "true");
      }
    };

    vm.upperRibbonStateChange = function(isUpperRibbonRequired){
      vm.isUpperRibbonRequired = isUpperRibbonRequired;
    };

    vm.isUpperRibbonRequired = localStorage.getItem("isUpperRibbonDismissed") === null ? true : false;
  }

  vm.numberWithCommas = function(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
}
